import { AnyAction } from 'redux';
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { App, GegeVorbelegungdaten, VorvertragVorschaeden } from '@ps20-frontend/frontend-models';
import { VorschadenArt } from '@ps20/bff-models';
import { GegeActions } from '../gegeActions';

export interface FahrradVorschaeden {
  provided: boolean;
  count: number;
  manuallyEntered: boolean;
}

export const fahrradVorschaedenReducer = function (
  sectionState: FahrradVorschaeden = null,
  action: AnyAction,
  angebotsId?: string,
): FahrradVorschaeden {
  switch (action.type) {
    case GegeActions.FAHRRAD_VORSCHAEDEN_COUNT_CHANGED: {
      return {
        ...sectionState,
        count: action.payload.value,
        manuallyEntered: true,
      };
    }
    case GegeActions.FAHRRAD_VORSCHAEDEN_VORHANDEN_CHANGED: {
      return {
        ...sectionState,
        provided: action.payload.provided,
        count: action.payload.provided ? sectionState.count : 0,
        manuallyEntered: true,
      };
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const actionPayload: GegeVorbelegungdaten = action.payload;
      if (actionPayload.forApp === App.GEGE && actionPayload.angebotsId === angebotsId) {
        return {
          ...sectionState,
          provided: actionPayload.bicycleClaims > 0,
          count: actionPayload.bicycleClaims ? actionPayload.bicycleClaims : 0,
          manuallyEntered: false,
        };
      }
      return sectionState;
    }
    case GlobalActions.VORVERTRAG_VORSCHAEDEN_ERMITTELT: {
      const actionPayload: Array<VorvertragVorschaeden> = action.payload;
      const vorvertragVorschaeden = actionPayload.find(
        vv =>
          vv.appId === App.GEGE &&
          vv.angebotsId === angebotsId &&
          vv.vorschaedenArt === VorschadenArt.RAD,
      );
      if (vorvertragVorschaeden == null) {
        return sectionState;
      }
      const anzahl =
        vorvertragVorschaeden.anzahlVorschaeden > 0 ? vorvertragVorschaeden.anzahlVorschaeden : 0;
      return {
        ...sectionState,
        provided: anzahl > 0,
        count: anzahl,
        manuallyEntered: false,
      };
    }
    default:
      return sectionState;
  }
};
